import { Close } from '@audio-network/componentlibrary/icons'
import clsx from 'clsx'

import { StatusToastProps } from './StatusToast.types'
import styles from './Toast.module.css'

const StatusToast = ({
	children,
	toastProps,
	startIcon,
	...props
}: StatusToastProps): JSX.Element => {
	const { ...restProps } = props
	const { type, closeToast } = toastProps

	const isError = type === 'error'

	return (
		<div className={clsx(styles.toast, styles[type])} {...restProps}>
			{startIcon && startIcon}
			{children}
			{/* TODO: This needs to be screen readable */}
			{isError && (
				<button onClick={closeToast} className={styles.closeButton}>
					<Close />
				</button>
			)}
		</div>
	)
}

export default StatusToast
